import React, { useState } from 'react';
import PropTypes from 'prop-types';
import propertyService from '../../services/propertyService';
import FormField from '../common/FormField';
import Alert from '../common/Alert';
import { validateEmail } from '../../utils/validators';
import '../../pages/ApplicantPages.css';

// Invite one named person. They get a personal link by email.
const InviteApplicantCard = ({ organisationId, propertyId, onInvited }) => {
  const [values, setValues] = useState({ email: '', first_name: '', last_name: '' });
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState(null);

  const change = (e) => setValues((v) => ({ ...v, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    const emailError = validateEmail(values.email);
    if (emailError) {
      setErrors({ email: emailError });
      return;
    }
    setErrors({});
    setNotice(null);
    setBusy(true);
    try {
      await propertyService.inviteApplicant(organisationId, propertyId, values);
      setNotice({ type: 'success', message: `Invitation sent to ${values.email}. They will get a personal link by email.` });
      setValues({ email: '', first_name: '', last_name: '' });
      if (onInvited) onInvited();
    } catch (err) {
      const apiErrors = err.response?.data?.errors;
      if (apiErrors) {
        setErrors(Object.fromEntries(Object.entries(apiErrors).map(([k, v]) => [k.replace('applicant_', ''), v[0]])));
      } else {
        setNotice({ type: 'error', message: err.response?.data?.message || 'The invitation could not be sent.' });
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="ap-card" aria-labelledby="invite-title">
      <h2 id="invite-title">Invite an applicant</h2>
      <p className="ap-muted">Already have someone in mind? Send them a personal link to apply for this property.</p>
      {notice && <Alert type={notice.type} message={notice.message} dismissible onClose={() => setNotice(null)} />}
      <form onSubmit={submit} noValidate>
        <FormField label="Email address" name="email" type="email" value={values.email} onChange={change} error={errors.email} required />
        <div className="ap-row">
          <FormField label="First name" name="first_name" value={values.first_name} onChange={change} error={errors.first_name} />
          <FormField label="Last name" name="last_name" value={values.last_name} onChange={change} error={errors.last_name} />
        </div>
        <button type="submit" className="btn-primary ap-button" disabled={busy}>{busy ? 'Sending...' : 'Send invitation'}</button>
      </form>
    </section>
  );
};

InviteApplicantCard.propTypes = {
  organisationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  propertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onInvited: PropTypes.func
};

export default InviteApplicantCard;
